import { render } from "./FieldVitalityCheckSugarbeetIcon.vue?vue&type=template&id=fe8608b0"
import script from "./FieldVitalityCheckSugarbeetIcon.vue?vue&type=script&lang=js"
export * from "./FieldVitalityCheckSugarbeetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__